import { statisticsTopic } from '../types/tutor-on-demand-statistics.types'

export const statisticsTopicList = {
  [statisticsTopic.GATHERING_DATA]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/aa-samle-data',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-does-data-gathering-mean',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-oznachaye-zbyrannya-danykh',
  },
  [statisticsTopic.INVESTIGATING_DATA]: {
    no: '',
    en: '',
    uk: '',
  },
  [statisticsTopic.FREQUENCY_TABLES]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/aa-lage-frekvenstabell',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-are-frequency-tables',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-chastotni-tablytsi',
  },
  [statisticsTopic.RELATIVE_AND_CUMULATIVE_FREQUENCY]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/relativ-frekvens-og-kumulativ-frekvens',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-is-relative-frequency-and-cumulative-frequency',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-vidnosna-y-nakopychena-chastota',
  },
  [statisticsTopic.VALIDITY]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/viktige-begreper',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-is-statistical-validity-and-reliability',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-statystychna-validnist-ta-nadiynist',
  },
  [statisticsTopic.RELIABILITY]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/viktige-begreper',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-is-statistical-validity-and-reliability',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-statystychna-validnist-ta-nadiynist',
  },
  [statisticsTopic.REPRESENTATIVITY]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/viktige-begreper',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-is-statistical-validity-and-reliability',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-statystychna-validnist-ta-nadiynist',
  },
  [statisticsTopic.SIGNIFICANCE]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/viktige-begreper',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-is-statistical-validity-and-reliability',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-statystychna-validnist-ta-nadiynist',
  },
  [statisticsTopic.RANDOM_VARIABLES]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/sannsynlighet-og-kombinatorikk/sannsynlighetsfordelinger/tilfeldige-variabler-hendelser-og-utfall',
    en: '/encyclopedia/statistics-and-probability/probability-and-combinatorics/probability-distributions/random-variable-vs-event',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/imovirnist-i-kombinatoryka/rozpodily-ymovirnostey/vypadkova-velychyna-abo-podiya',
  },
  [statisticsTopic.OBSERVATIONS]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/samle-data/viktige-begreper',
    en: '/encyclopedia/statistics-and-probability/statistics/collecting-data/what-is-statistical-validity-and-reliability',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/zbyrannya-danykh/shcho-take-statystychna-validnist-ta-nadiynist',
  },
  [statisticsTopic.CENTRAL_TENDENCIES]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/sentralmaal',
    en: '/encyclopedia/statistics-and-probability/statistics/central-tendency',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/tsentralna-tendentsiya',
  },
  [statisticsTopic.MODE]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/sentralmaal/typetall/typetall',
    en: '/encyclopedia/statistics-and-probability/statistics/central-tendency/mode/what-is-mode-in-statistics',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/tsentralna-tendentsiya/moda',
  },
  [statisticsTopic.MEDIAN]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/sentralmaal/median',
    en: '/encyclopedia/statistics-and-probability/statistics/central-tendency/median',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/tsentralna-tendentsiya/mediana',
  },
  [statisticsTopic.MEAN]: {
    no: '/encyclopedia/statistikk-og-sannsynlighet/statistikk/sentralmaal/median/sentralmaal-median',
    en: '/encyclopedia/statistics-and-probability/statistics/central-tendency/mean-and-expected-value/what-is-arithmetic-mean',
    uk: '/encyclopedia/statystyka-ta-ymovirnist/statystyka/tsentralna-tendentsiya/serednye-aryfmetychne-ta-matematychne-spodivannya/shcho-take-serednye-aryfmetychne',
  },
}
